import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/83993218-9457-4f09-b22a-3caef4db7ad5/images/eab94033568ab730de1a5e7f0d295e266739599e3a2f9adfd236f4f30bc80a67.jpeg";

const links = [
  { to: "/", label: "Accueil", testId: "nav-home" },
  { to: "/huttes", label: "Les huttes", testId: "nav-huts" },
  { to: "/reserver", label: "Réserver", testId: "nav-book" },
  { to: "/informations", label: "Informations pratiques", testId: "nav-info" },
  { to: "/reglement", label: "Règlement intérieur", testId: "nav-rules" },
  { to: "/localisation", label: "Localisation", testId: "nav-location" },
  { to: "/contact", label: "Contact", testId: "nav-contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-[#FAF8F5]/95 backdrop-blur-md border-b border-stone-200" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-4 h-24 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <img src={LOGO_URL} alt="Logo AGCVS" className="h-16 w-16 sm:h-20 sm:w-20 object-contain" />
          <div className="leading-tight">
            <div className="font-serif text-2xl sm:text-3xl font-bold text-emerald-900">AGCVS</div>
            <div className="text-xs sm:text-sm uppercase tracking-wider text-stone-500">Vallée de Somme</div>
          </div>
        </Link>
        <nav className="hidden lg:flex items-center gap-1">
          {links.map(l => (
            <NavLink key={l.to} to={l.to} data-testid={l.testId}
              className={({isActive}) => `px-3 py-2 text-sm rounded-md transition ${isActive ? "text-emerald-900 bg-emerald-50 font-semibold" : "text-stone-600 hover:text-emerald-900 hover:bg-stone-100"}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:block">
          <Link to="/admin/login" className="text-xs text-stone-500 hover:text-emerald-900" data-testid="admin-link">Admin</Link>
        </div>
        <button onClick={() => setOpen(!open)} className="lg:hidden p-2" data-testid="menu-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-stone-200 bg-white" data-testid="mobile-menu">
          {links.map(l => (
            <NavLink key={l.to} to={l.to} data-testid={`m-${l.testId}`}
              onClick={() => setOpen(false)}
              className={({isActive}) => `block px-4 py-3 text-sm border-b border-stone-100 ${isActive ? "text-emerald-900 bg-emerald-50 font-semibold" : "text-stone-700"}`}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/admin/login" onClick={() => setOpen(false)} className="block px-4 py-3 text-xs text-stone-500" data-testid="m-admin-link">Espace administrateur</Link>
        </div>
      )}
    </header>
  );
}
